import { AxiosResponse, InternalAxiosRequestConfig, AxiosInstance } from 'axios'
import { AUTH_STORAGE_KEYS } from '@/types'

export function setupRequestInterceptor(apiClient: AxiosInstance): void {
  apiClient.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const token = localStorage.getItem(AUTH_STORAGE_KEYS.TOKEN)
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
}

export function setupResponseInterceptor(apiClient: AxiosInstance): void {
  apiClient.interceptors.response.use(
    (response: AxiosResponse) => {
      return response
    },
    async error => {
      const originalRequest = error.config

      if (error.response?.status === 401) {
        if (isExcludedRefreshRequest(originalRequest.url)) {
          return Promise.reject(error)
        }

        const refreshToken = localStorage.getItem(
          AUTH_STORAGE_KEYS.REFRESH_TOKEN
        )

        if (refreshToken) {
          try {
            delete originalRequest.headers.Authorization
            const response = await apiClient.post('/auth/refresh', {
              refresh_token: refreshToken,
            })

            if (response.status === 401) {
              clearAuthData()
              redirectToLogin()
              return Promise.reject(error)
            }

            const { access_token } = response.data

            localStorage.setItem(AUTH_STORAGE_KEYS.TOKEN, access_token)
            originalRequest.headers.Authorization = `Bearer ${access_token}`

            return apiClient(originalRequest)
          } catch (refreshError) {
            clearAuthData()
            redirectToLogin()
            return Promise.reject(refreshError)
          }
        }
      }

      return Promise.reject(error)
    }
  )
}

function clearAuthData() {
  localStorage.removeItem(AUTH_STORAGE_KEYS.TOKEN)
  localStorage.removeItem(AUTH_STORAGE_KEYS.REFRESH_TOKEN)
  localStorage.removeItem(AUTH_STORAGE_KEYS.USER)
}

function redirectToLogin(): void {
  window.location.href = '/login'
}

function isExcludedRefreshRequest(url: Maybe<string>): boolean {
  const EXCLUDED_TOKEN_REFRESH_URLS = ['/auth/']
  if (!url) return false
  return EXCLUDED_TOKEN_REFRESH_URLS.some(excludedUrl =>
    url.includes(excludedUrl)
  )
}
